import AddBossModeAccount from './AddBossModeAccount.component';

export default AddBossModeAccount;